export default __webpack_public_path__ + "static/media/1-0.6f5f2eb6.png";